import { Link } from "react-router-dom";
import { useI18n } from "../I18nContext";

export default function Toolbox() {
  const { t } = useI18n();
  return (
    <div className="tb-page">
      <h1 className="tb-h1" data-testid="toolbox-heading">
        {t("toolbox.title")}
      </h1>
      <p className="tb-muted" style={{ marginBottom: "2rem" }}>
        {t("toolbox.subtitle")}
      </p>

      <div className="tb-card-grid">
        <Link to="/app/frameworks" className="tb-app-card" data-testid="toolbox-frameworks" style={{ textDecoration: "none" }}>
          <span className="tb-badge good">{t("toolbox.live")}</span>
          <strong>{t("toolbox.frameworksTitle")}</strong>
          <small>{t("toolbox.frameworksBody")}</small>
        </Link>
        <Link to="/app/solutions" className="tb-app-card" data-testid="toolbox-offers-services" style={{ textDecoration: "none" }} aria-disabled="true">
          <span className="tb-badge accent">{t("toolbox.comingSoon")}</span>
          <strong>{t("toolbox.offersServicesTitle")}</strong>
          <small>{t("toolbox.offersServicesBody")}</small>
        </Link>
      </div>
    </div>
  );
}
